export default __webpack_public_path__ + "static/media/cloud-storage.eabcaba6.svg";